import React from 'react'
import PropTypes from 'prop-types'


class ScheduleDownloadButton extends React.PureComponent {

  render() {
    return (
      <div className="fileinput fileinput-new" data-provides="fileinput">
        <span className="btn btn-secondary btn-sm btn-file">
          <span className="fa fa-download" />
          {
            this.props.isDownloading
              ? <span> Downloading </span>
              : <span> Download Schedule</span>
          }
          <input
            type="button"
            disabled={this.props.isDownloading}
            onClick={this.props.onClick}
          />
        </span>
      </div>
    )
  }
}


ScheduleDownloadButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isDownloading: PropTypes.bool.isRequired
}

export default ScheduleDownloadButton



// WEBPACK FOOTER //
// ./src/components/scheduleDownload/index.js